import { format } from 'date-fns'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { destroy } from 'redux-form'
import { Box, Card } from '@material-ui/core'

import CheckoutForm from '../components/checkout/CheckoutForm'
import { ValidationModal } from '../components/place-order'
import { loadCheckoutCartStart } from '../redux/modules/cart'
import { resetCheckoutError, loadAvailableProgramStart } from '../redux/modules/checkout'
import { loadPaymentMethodsStart } from '../redux/modules/paymentMethods'
import { loadAvailableCreditsStart } from '../redux/modules/creditHistory'
import { loadDeliveryDropoffStart } from '../redux/modules/delivery'
import { selectCurrentLocationWithAddress } from '../redux/modules/selectors'
import CheckoutSidebar from '../components/checkout/CheckoutSidebar'
import RestaurantDetails from '../components/common/RestaurantDetails'
import LayoutInnerPage, { HeaderInnerPage } from '../layouts/LayoutInnerPage'
import { formatUrl } from '../util/formatUtils'
import { placeOrderRoute } from '../routes/routes'

const PageCheckout = ({
  match: {
    params: { dropoffId = 0, locationId = 0 },
  },
  checkoutCart,
  resetCheckoutError,
  deliveryError,
  destroy,
  loadAvailableCreditsStart,
  loadAvailableProgramStart,
  loadCheckoutCartStart,
  loadPaymentMethodsStart,
  loadDeliveryDropoffStart,
  deliveryDropoff,
}) => {
  // runs once on mount, and returned function runs on unmount
  useEffect(() => {
    loadPaymentMethodsStart()
    loadAvailableCreditsStart()
    return () => {
      resetCheckoutError()
      destroy('checkout')
    }
  }, [resetCheckoutError, destroy, loadAvailableCreditsStart, loadPaymentMethodsStart])

  // when dropoffId updates
  useEffect(() => {
    const numId = Number(dropoffId)
    if (numId) {
      loadDeliveryDropoffStart(numId)
    }
  }, [dropoffId, loadCheckoutCartStart, loadDeliveryDropoffStart])

  // When subscription value changes
  useEffect(() => {
    const numId = Number(dropoffId)
    if (numId) {
      loadCheckoutCartStart(numId)
    }
  }, [dropoffId, loadCheckoutCartStart])

  // when orderDate changes
  useEffect(() => {
    if (checkoutCart.orderDate) {
      loadAvailableProgramStart(format(checkoutCart.orderDate, 'YYYY-MM-DD'))
    }
  }, [checkoutCart.orderDate, loadAvailableProgramStart])

  locationId = Number(locationId)

  if (deliveryError) {
    const serverMessage = deliveryError.response ? deliveryError.response.data : ''
    return <ValidationModal locationId={locationId} serverMessage={serverMessage} />
  }

  return (
    <LayoutInnerPage
      HeaderComponent={
        <HeaderInnerPage
          showBackButton
          backButtonRoute={formatUrl(placeOrderRoute.path, { locationId, dropoffId })}
        >
          Checkout
        </HeaderInnerPage>
      }
      MainComponent={
        <Card>
          <Box marginY={3}>
            <RestaurantDetails logoLink={deliveryDropoff?.logo} name={deliveryDropoff?.storeName} />
          </Box>
          <CheckoutForm dropoffId={dropoffId} />
        </Card>
      }
      SidebarComponent={<CheckoutSidebar />}
    />
  )
}

const mapStateToProps = state => {
  const deliveryError = state.delivery.error
  const { deliveryDropoff } = state.delivery
  const { availableCredits } = state.creditHistory
  const { checkoutCart, couponUsage } = state.cart
  const location = selectCurrentLocationWithAddress(state)

  return {
    availableCredits,
    checkoutCart,
    couponUsage,
    deliveryError,
    location,
    deliveryDropoff,
  }
}

const mapDispatchToProps = {
  resetCheckoutError,
  destroy,
  loadAvailableCreditsStart,
  loadAvailableProgramStart,
  loadCheckoutCartStart,
  loadPaymentMethodsStart,
  loadDeliveryDropoffStart,
}
export default connect(mapStateToProps, mapDispatchToProps)(PageCheckout)
